module.exports = __webpack_public_path__ + "media/images/classpoints/brands/SR-e77ff03990b8d2807a3e7a484dfff93e.svg";